import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from './containers/home'
import Archives from './containers/archives'
import About from './containers/about'
import NotFound from './containers/notFound'
import Article from './containers/article'

const routes = () => (
  <Switch>
    {/* Main Header Page Routes */}
    <Route exact path='/' component={Home} />
    <Route exact path='/archives' component={Archives} />
    <Route exact path='/about' component={About} />
    {/* Individual Page Routes */}
    <Route path='/article/:year/:month/:articleName' component={Article} />
    <Route component={NotFound} />
  </Switch>
)

export default routes



// WEBPACK FOOTER //
// ./src/client/routes.js